<template>
    <div class="hospitalList wow-table-header">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap-user">
            <!-- <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">用户列表</span>
            </div> -->
            <el-tabs v-model="activeName"
                     type="card"
                     class="order-tabs"
                     @tab-click="handleTabClick">
                <el-tab-pane v-for="(item,index) in tabList" :key = index
                             :label= item.dictDataValue
                             :name= item.identities></el-tab-pane>
            </el-tabs>
            <div class="user-list-wrap">
                <div class="select-form">
                    <div class="show-wrap">
                        <div class="search-show-wrap">
                            <el-input class="search-input"
                                    size="small"
                                    placeholder="搜索姓名、工号"
                                    v-model="selectForm.searchName"
                                    @keyup.enter.native="searchDoctor('search')">
                                <i slot="suffix"
                                class="iconfont icon-search"
                                @click="searchDoctor('search')"></i>
                            </el-input>
                            <div class="more-search"
                                @click="isMoreShow=!isMoreShow">
                                <span class="more-search-text">高级搜索</span>
                                <i class="iconfont icon-drop_down"
                                :class="[{'is-reverse': isMoreShow}]"></i>
                            </div>
                        </div>
                        <div>
                            <el-button size="small"
                                    @click="toAdd">{{activeName === 'doctor'?'新增医生':'新增护士'}}</el-button>
                            <el-button size="small"
                                    type="primary"
                                    @click="handleExport">导出数据</el-button>
                        </div>
                    </div>
                    <div class="hide-wrap"
                        v-if="isMoreShow">
                        <div class="option-wrap">
                            <div class="option-item">
                                <span class="label">姓名</span>
                                <el-input size="small"
                                        placeholder="请输入姓名"
                                        :style="{width: '220px'}"
                                        v-model="selectForm.accountName">
                                </el-input>
                            </div>
                            <div class="option-item">
                                <span class="label">工号</span>
                                <el-input size="small"
                                        placeholder="请输入工号"
                                        :style="{width: '220px'}"
                                        v-model="selectForm.accountNumber">
                                </el-input>
                            </div>
                            <div class="option-item">
                                <span class="label">医院</span>
                                <el-autocomplete v-model="selectForm.hospitalName"
                                                size="small"
                                                value-key="hospitalName"
                                                :style="{width: '220px'}"
                                                :fetch-suggestions="getHospital"
                                                placeholder="请输入医院"></el-autocomplete>
                                <!-- <el-input size="small"
                                        placeholder="请输入医院名称"
                                        :style="{width: '220px'}"
                                        v-model="selectForm.hospitalName">
                                </el-input> -->
                            </div>
                            <div class="option-item">
                                <span class="label">科室</span>
                                <el-autocomplete v-model="selectForm.dept"
                                                size="small"
                                                value-key="groupName"
                                                :style="{width: '220px'}"
                                                :fetch-suggestions="getDepart"
                                                placeholder="请输入科室"></el-autocomplete>
                            </div>
                            <!-- <div class="option-item" v-if="activeName==='doctor'">
                                <span class="label label-group">医生集团</span>
                                <el-autocomplete v-model="selectForm.groupName"
                                                size="small"
                                                value-key="groupName"
                                                :style="{width: '220px'}"
                                                :fetch-suggestions="getGroup"
                                                placeholder="请输入医生集团"></el-autocomplete>
                            </div> -->

                            <div class="option-item1">
                                <span class="label">最近活跃时间</span>
                                <el-date-picker size="small"
                                                clearable
                                                clear-icon="el-icon-error"
                                                v-model="selectForm.lastTime"
                                                type="daterange"
                                                range-separator="-"
                                                start-placeholder="yyyy-mm-dd"
                                                end-placeholder="yyyy-mm-dd"
                                                value-format="yyyy-MM-dd"
                                                :style="{width: '240px'}"
                                                :picker-options="datePickerOptions">
                                </el-date-picker>
                            </div>
                            <div class="select-btn-wrap">
                                <el-button type="primary"
                                        size="small"
                                        @click="searchDoctor('search')">查询</el-button>
                                <el-button type="info"
                                        size="small"
                                        plain
                                        @click="searchDoctor('reset')">重置</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-wrap">
                    <el-table :data="doctorList"
                            stripe
                            @sort-change="handleLastTimeChange"
                            :default-sort="{prop: 'lastTime', order: 'descending'}"
                            v-loading="loading"
                            style="width: 100%">
                        <el-table-column prop="name"
                                        width="90px"
                                        type="index"
                                        label="序号">
                        </el-table-column>
                        <el-table-column min-width="90px"
                                        label="姓名">
                            <template slot-scope="scope">
                                {{scope.row.accountName || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90px"
                                        label="工号">
                            <template slot-scope="scope">
                                {{scope.row.accountNumber || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90px"
                                        label="手机号">
                            <template slot-scope="scope">
                                {{scope.row.phone || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="150px"
                                        label="医院">
                            <template slot-scope="scope">
                                {{scope.row.hospitalName || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90px"
                                        label="科室">
                            <template slot-scope="scope">
                                {{scope.row.departName || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90px"
                                        label="医生集团"
                                        v-if="activeName==='doctor'">
                            <template slot-scope="scope">
                                {{scope.row.groups || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90px"
                                        label="职称">
                            <template slot-scope="scope">
                                {{scope.row.titleName || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="90px"
                                        label="角色">
                            <template slot-scope="scope">
                                {{scope.row.roles || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="lastTime"
                                        min-width="145px"
                                        label="最近活跃时间"
                                        sortable
                                        :sort-orders="['ascending', 'descending']">
                            <template slot-scope="scope">
                                {{scope.row.lastTime || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="name"
                                        width="160px"
                                        fixed="right"
                                        label="操作">
                            <template slot-scope="scope">
                                <span class="link-btn"
                                    @click="goDetail(scope.row, 'show')">查看</span>
                                <span class="link-btn"
                                    @click="goDetail(scope.row, 'edit')">编辑</span>
                                <span class="link-btn"
                                    @click="changePassword(scope.row)">修改密码</span>
                            </template>
                        </el-table-column>
                        <div slot="empty"
                            class="table-none">
                            <div>
                                <svg-icon icon-class="none1" />
                            </div>
                            <span>暂无数据</span>
                        </div>
                    </el-table>
                </div>
                <div class="pagination-wrap">
                    <el-pagination background
                                @current-change="pageChange"
                                :current-page.sync="page.current"
                                :page-size="page.pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="page.total"></el-pagination>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="passVisible"
                   top="20vh"
                   title="修改密码"
                   width="454px"
                   :close-on-click-modal="false"
                   class="pass-dialog">
            <el-form :model="passForm"
                     ref="passForm"
                     label-width="70px"
                     :rules="passRules"
                     class="pass-passForm"
                     v-loading="passFormLoading">
                <el-form-item label="手机号">
                    <el-input v-model="passForm.phone"
                              disabled>
                    </el-input>
                </el-form-item>
                <el-form-item label="验证码"
                              prop="code"
                              :rules="[{ required: true, message: '请输入验证码', trigger: 'change'}, { required: true, message: '请输入验证码', trigger: 'blur'}]">
                    <el-input v-model="passForm.code"
                              auto-complete="new-password"
                              placeholder="请输入验证码">
                    </el-input>
                    <div class="get-code"
                         :class="[{'click-code': codeCanClick}]"
                         @click="getCode">{{codeStr}}</div>
                </el-form-item>
                <el-form-item label="新密码"
                              prop="newPassword"
                              style="width: 400px;">
                    <el-popover placement="right-start"
                                width="236px"
                                popper-class="userList-popover-hover"
                                trigger="hover">
                        <div class="pass-length">
                            <i class="el-icon-circle-check"
                               v-if="passShow"></i>
                            <i class="el-icon-circle-close"
                               v-else></i>
                            <p class="pass-text">长度为8-32个字符</p>
                        </div>
                        <div class="pass-rule">
                            <i class="el-icon-circle-check"
                               v-if="ruleShow"></i>
                            <i class="el-icon-circle-close"
                               v-else></i>
                            <p class="pass-text">数字、大小写字母以及特殊字符至少包含两种</p>
                        </div>
                        <el-input v-model="passForm.newPassword"
                                  slot="reference"
                                  type="password"
                                  maxlength="50"
                                  auto-complete="new-password"
                                  placeholder="请输入新密码">
                        </el-input>
                    </el-popover>
                </el-form-item>
                <el-form-item style="padding-bottom: 20px;">
                    <el-button type="primary"
                               class="commit-btn"
                               @click="handleCommitPass">确定</el-button>
                    <el-button class="cancle-btn"
                               @click="handleCancle">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { postSendVerification, putChangePassword } from '@/api/user'
export default {
    name: 'userList',
    data () {
        const checkPassword = (rule, value, callback) => {
            if (value === '') {
                this.passShow = false
                this.ruleShow = false
                callback(new Error('请输入新密码！'))
            } else {
                if (value.length > 32 || value.length < 8) {
                    this.passShow = false
                    callback(new Error('密码格式错误!'))
                } else {
                    this.passShow = true
                    // 判断密码强弱
                    let modes = this.checkPasswordStrong(value)
                    if (modes < 2) {
                        this.ruleShow = false
                        callback(new Error('密码格式错误!'))
                    } else {
                        this.ruleShow = true
                        callback()
                    }
                }
            }
        }
        return {
            breadList: [{ label: '用户管理' }, { label: '用户列表' }],
            datePickerOptions: {
                shortcuts: [{
                    text: '最近3天',
                    onClick (picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
                        picker.$emit('pick', [start, end])
                    }
                }, {
                    text: '最近7天',
                    onClick (picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit('pick', [start, end])
                    }
                }]
            },
            isMoreShow: false,
            passFormLoading: false,
            passVisible: false,
            passForm: {
                code: '',
                phone: '',
                iuid: '',
                newPassword: ''
            },
            selectForm: {
                searchName: '', // 模糊查询 医生姓名/工号
                accountName: '', // 医生姓名
                accountNumber: '', // 工号
                hospitalName: '',
                dept: '',
                groupName: '',
                lastTime: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 15,
                order: 'descending'
            },
            timerInterval: null,
            doctorList: [],
            loading: true,
            codeCanClick: true,
            passShow: false,
            ruleShow: false,
            codeStr: '获取验证码',
            passRules: {
                newPassword: [{ required: true, validator: checkPassword, trigger: 'change' }]
            },
            tabList: [
                {
                    identities: 'doctor',
                    dictDataValue: '医生'
                },
                {
                    identities: 'nurse',
                    dictDataValue: '护士'
                }
            ],
            activeName: 'doctor'
        }
    },
    computed: {
        ...mapGetters([
            'dictionary', 'userInfo'
        ])
    },
    created () {
        // const end = new Date()
        // const start = new Date()
        // start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
        // this.selectForm.lastTime = [start, end]
        this.getData()
    },
    methods: {
        handleTabClick () {
            // 清空筛选
            this.selectForm = {
                searchName: '', // 模糊查询 医生姓名/工号
                accountName: '', // 医生姓名
                accountNumber: '', // 工号
                hospitalName: '',
                dept: '',
                groupName: '',
                lastTime: ''
            }
            this.page.current = 1
            this.isMoreShow = false
            this.getData()
        },
        // 导出列表数据
        formatWayJson (filterVal, jsonData) {
            return jsonData.map((v, index) => {
                return filterVal.map((j) => {
                    if (j === 'index') {
                        return (index + 1)
                    } else {
                        return v[j]
                    }
                })
            })
        },
        // 导出
        handleExport () {
            this.getExportData().then(res => {
                let list = res
                this.loading = true
                import('@/vendor/Export2Excel').then(excel => {
                    let tHeader = []
                    let filterVal = []
                    if (this.activeName === 'doctor') {
                        tHeader = ['序号', '姓名', '工号', '手机号', '医院', '科室', '医生集团', '职称', '角色', '最近活跃时间']
                        filterVal = ['index', 'accountName', 'accountNumber', 'phone', 'hospitalName', 'departName', 'groups', 'titleName', 'roles', 'lastTime']
                    } else {
                        tHeader = ['序号', '姓名', '工号', '手机号', '医院', '科室', '职称', '角色', '最近活跃时间']
                        filterVal = ['index', 'accountName', 'accountNumber', 'phone', 'hospitalName', 'departName', 'titleName', 'roles', 'lastTime']
                    }
                    if (list.length > 0) {
                        const data = this.formatWayJson(filterVal, list)
                        let filename = '用户数据'
                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: filename,
                            autoWidth: true,
                            bookType: 'xlsx'
                        })
                        this.loading = false
                    } else {
                        this.$message({
                            message: '无数据导出！',
                            type: 'warning',
                            center: true
                        })
                        this.loading = false
                    }
                })
            })
        },
        async getExportData () {
            let ascs = []
            let descs = []
            if (this.page.order === 'ascending') {
                ascs = ['last_time']
            }
            if (this.page.order === 'descending') {
                descs = ['last_time']
            }
            let lastTimeStart = ''
            let lastTimeEnd = ''
            if (this.selectForm.lastTime) {
                lastTimeStart = this.selectForm.lastTime[0] + ' 00:00:00'
                lastTimeEnd = this.selectForm.lastTime[1] + ' 23:59:59'
            }
            const param = {
                current: 1,
                size: -1,
                hospitalName: this.selectForm.hospitalName,
                accountNumber: this.selectForm.accountNumber,
                accountName: this.selectForm.accountName,
                groupName: this.selectForm.groupName,
                departmentName: this.selectForm.dept,
                searchName: this.selectForm.searchName,
                lastTimeStart: lastTimeStart,
                lastTimeEnd: lastTimeEnd,
                ascs: ascs,
                descs: descs,
                identities: this.activeName
            }
            if (this.selectForm.accountNumber || this.selectForm.accountName) {
                param.searchName = ''
            }
            const { results } = await this.$services.hospital.getDoctorList(param)

            for (let i in results) {
                // 科室名字
                if (results[i].departmentVO) {
                    results[i].departName = results[i].departmentVO.groupName
                }
                // 医生集团
                if (results[i].groupVOs) {
                    let group = results[i].groupVOs
                    let arr = []
                    for (let j in group) {
                        arr.push(group[j].groupName)
                    }
                    results[i].groups = arr.join(' | ')
                }
                // 角色
                if (results[i].roles) {
                    let roles = results[i].roles
                    let arr = []
                    for (let j in roles) {
                        arr.push(roles[j].roleName)
                    }
                    results[i].roles = arr.join(' | ')
                }
            }
            return new Promise((resolve, reject) => {
                resolve(results)
            })
        },
        // 排序
        handleLastTimeChange (column) {
            this.page.order = column.order
            this.page.current = 1
            this.getData()
        },
        // 点击修改密码
        changePassword (row) {
            this.passShow = false
            this.ruleShow = false
            this.passForm.phone = this.userInfo.phone
            this.passForm.iuid = row.iuid
            this.passForm.newPassword = ''
            this.passForm.code = ''
            this.passVisible = true
            if (this.$refs['passForm']) {
                this.$refs['passForm'].resetFields()
            }
        },
        handleCancle () {
            this.passVisible = false
            clearInterval(this.timerInterval)
            this.codeCanClick = true
            this.codeStr = '获取验证码'
        },
        // 确定修改密码
        handleCommitPass () {
            this.$refs['passForm'].validate((valid) => {
                if (valid) {
                    this.handleSavePass()
                } else {
                    return false
                }
            })
        },
        async handleSavePass () {
            let params = {
                code: this.passForm.code,
                iuid: this.passForm.iuid,
                newPassword: this.passForm.newPassword
            }
            this.passFormLoading = true
            const { results } = await putChangePassword(params)
            if (results === 'OK') {
                this.passVisible = false
                this.$message({
                    message: '成功修改密码！',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
            }
            this.passFormLoading = false
        },
        // 获取验证码倒计时
        getCode () {
            if (!this.codeCanClick) {
                return
            }
            const phoneTest = /^[1][3,4,5,7,8,9][0-9]{9}$/
            if (!this.passForm.phone || !phoneTest.test(this.passForm.phone)) {
                return
            }
            let timer = 60
            this.codeStr = timer + 's'
            this.codeCanClick = false
            this.timerInterval = setInterval(() => {
                timer--
                if (timer < 1) {
                    clearInterval(this.timerInterval)
                    this.codeCanClick = true
                    this.codeStr = '获取验证码'
                } else {
                    this.codeStr = timer + 's'
                }
            }, 1000)
            this.handleVerification()
        },
        async handleVerification () {
            let params = {
                phone: this.passForm.phone,
                signName: '树兰医疗'
            }
            await postSendVerification(params)
        },
        searchDoctor (type) {
            if (type === 'search') {
                this.page.current = 1
                this.getData()
            } else if (type === 'reset') {
                this.page.current = 1
                this.selectForm.hospitalName = ''
                this.selectForm.dept = ''
                this.selectForm.groupName = ''
                this.selectForm.accountName = ''
                this.selectForm.accountNumber = ''
                this.selectForm.searchName = ''
                this.selectForm.lastTime = ''
                this.getData()
            }
        },
        pageChange (value) {
            this.page.current = value
            this.getData()
        },
        // 搜索科室
        async getGroup (queryString, cb) {
            const params = {
                searchName: queryString
            }
            const { results } = await this.$services.hospital.getAllHospitalGroupList(params)
            cb(results)
        },
        // 医院搜索
        async getHospital (queryString, cb) {
            const params = {
                searchName: queryString
            }
            let arry = []
            const { results } = await this.$services.hospital.getAllHospitalList(params)
            if (results && results.length > 0) {
                arry = results
            }
            cb(arry)
        },
        // 搜索科室
        async getDepart (queryString, cb) {
            const params = {
                searchName: queryString,
                isStandard: false,
                departmentLevel: '2'
            }
            const { results } = await this.$services.hospital.getAllDeptList(params)
            cb(results)
        },
        async getData () {
            this.loading = true
            let ascs = []
            let descs = []
            if (this.page.order === 'ascending') {
                ascs = ['last_time']
            }
            if (this.page.order === 'descending') {
                descs = ['last_time']
            }

            let lastTimeStart = ''
            let lastTimeEnd = ''
            if (this.selectForm.lastTime) {
                lastTimeStart = this.selectForm.lastTime[0] + ' 00:00:00'
                lastTimeEnd = this.selectForm.lastTime[1] + ' 23:59:59'
            }
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                hospitalName: this.selectForm.hospitalName,
                accountNumber: this.selectForm.accountNumber,
                accountName: this.selectForm.accountName,
                groupName: this.selectForm.groupName,
                departmentName: this.selectForm.dept,
                searchName: this.selectForm.searchName,
                lastTimeStart: lastTimeStart,
                lastTimeEnd: lastTimeEnd,
                ascs: ascs,
                descs: descs,
                identities: this.activeName
            }
            if (this.selectForm.accountNumber || this.selectForm.accountName) {
                param.searchName = ''
            }
            const { results, total } = await this.$services.hospital.getDoctorList(param)
            this.doctorList = results || []
            this.detailData(results)
            this.page.total = total
            this.loading = false
        },
        // 处理数据
        detailData (data) {
            for (let i in data) {
                // 科室名字
                if (data[i].departmentVO) {
                    this.doctorList[i].departName = data[i].departmentVO.groupName
                }
                // 医生集团
                if (data[i].groupVOs) {
                    let group = data[i].groupVOs
                    let arr = []
                    for (let j in group) {
                        arr.push(group[j].groupName)
                    }
                    this.doctorList[i].groups = arr.join(' | ')
                }
                // 角色
                if (data[i].roles) {
                    let roles = data[i].roles
                    let arr = []
                    for (let j in roles) {
                        arr.push(roles[j].roleName)
                    }
                    this.doctorList[i].roles = arr.join(' | ')
                }
            }
        },
        toAdd () {
            if (this.activeName === 'doctor') {
                this.$router.push('/user/userList/add')
            } else {
                this.$router.push('/user/userList/add/nurse')
            }
        },
        goDetail (item, type) {
            let rouerName = this.activeName === 'doctor' ? 'userDetail' : 'nurseDetail'
            this.$router.push({
                name: rouerName,
                query: { doctorIuid: item.iuid, type: type }
            })
        },
        // 判断密码强弱
        checkPasswordStrong (password) {
            let modes = 0
            if (/\d/.test(password)) { // 数字
                modes++
            }
            if (/[a-z]/.test(password) || /[A-Z]/.test(password)) { // 大小写
                modes++
            }
            if (/\W/.test(password)) { // 特殊字符
                modes++
            }
            return modes
        }
    }
}
</script>

<style lang="scss">
.wow-table-header {
    .el-table {
        .caret-wrapper {
            height: 18px;
        }
        .sort-caret.ascending {
                top: -3px;
        }
        .sort-caret.descending {
            top: 9px;
        }
    }
}
.hospitalList {
    .show-wrap {
        .el-button--small {
            width: 86px;
            font-size: 14px;
            padding: 8px 15px;
        }
    }
    .select-btn-wrap {
        font-size: 0;
        .el-button--small {
            width: 80px;
            padding: 8px 15px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background: #f5f5f5;
            border-color: #cccccc;
            color: #666;
        }
    }
    .option-item {
        .el-select {
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .option-item1{
        .el-select {
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
}

.pass-dialog {
    .el-dialog__body {
        .pass-passForm {
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
            }
            .el-input {
                .el-input__inner {
                    background: #ffffff;
                    border: 1px solid #dcdcdc;
                    border-radius: 3px;
                    width: 330px;
                    height: 32px;
                    padding: 5px 10px;
                }
            }
            .commit-btn {
                width: 100px;
                height: 32px;
                font-family: PingFang-SC-Regular;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 4px;
                padding: 0;
            }
            .cancle-btn {
                width: 100px;
                height: 32px;
                font-family: PingFang-SC-Regular;
                font-size: 14px;
                color: #666;
                letter-spacing: 4px;
                padding: 0;
                border: 1px solid #dbdbdb;
            }
        }

        .get-code {
            position: absolute;
            top: 2px;
            // right: 121px;
            right: 15px;
            height: 28px;
            line-height: 28px;
            width: 100px;
            text-align: center;
            border-left: 1px solid #dcdcdc;
            background: #f6f6f6;
            color: #999999;
            font-size: 14px;
            cursor: not-allowed;
            border-radius: 3px;
        }
        .click-code {
            background: #fff;
            color: #666;
            cursor: pointer;
        }
        .el-input__suffix {
            .el-input__icon {
                line-height: 32px;
            }
        }
    }
}

.userList-popover-hover {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    .pass-length {
        display: flex;
        align-items: center;
        height: 20px;
        .el-icon-circle-check {
            color: #4acfb1;
            font-size: 12px;
            margin-right: 5px;
        }
        .el-icon-circle-close {
            color: #ec6a69;
            margin-right: 5px;
            font-size: 12px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            width: 220px;
        }
    }
    .pass-rule {
        display: flex;
        align-items: flex-start;
        height: 20px;
        padding-bottom: 14px;
        .el-icon-circle-check {
            color: #4acfb1;
            font-size: 12px;
            margin-right: 5px;
            margin-top: 3px;
        }
        .el-icon-circle-close {
            color: #ec6a69;
            margin-right: 5px;
            font-size: 12px;
            margin-top: 3px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            width: 220px;
            line-height: 18px;
        }
    }
}
.info-wrap-user {
    .order-tabs {
        .el-tabs__header {
            background: #f8f8f8;
            margin: 0;
            border-bottom: 1px solid #e8e8e8;
            .el-tabs__nav-wrap {
                margin-bottom: -1px;
            }
            .el-tabs__nav {
                border-radius: 0;
                height: 40px;
                .el-tabs__item {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    letter-spacing: 0;
                    text-align: center;
                    width: 170px;
                    height: 40px;
                    line-height: 38px;
                    border: none;
                    border-right: 1px solid #dbdbdb;
                }
                .is-active {
                    background: #ffffff;
                    color: #06aea6;
                    border-top: 2px solid #06aea6;
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.info-wrap-user {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    overflow: auto;
    .user-list-wrap {
        padding: 20px;
    }
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.show-wrap {
    display: flex;
    justify-content: space-between;
    .search-show-wrap {
        display: flex;
    }
    .more-search {
        font-size: 0;
        color: #666;
        padding-left: 10px;
        cursor: pointer;
    }
    .more-search-text {
        font-size: 14px;
        line-height: 32px;
        padding-right: 3px;
    }
    .icon-drop_down {
        display: inline-block;
        font-size: 12px;
        color: #999;
        transition: transform 0.3s;
        transform: rotateZ(180deg);
        &.is-reverse {
            transform: rotateZ(0deg);
        }
    }
}
.hide-wrap {
    margin-top: 8px;
    background: #f7f7f7;
    border: 1px solid #e6e6e6;
    padding: 20px 20px 0 20px;
}

.option-item {
    display: inline-block;
    font-size: 0;
    margin-right: 20px;
    margin-bottom: 20px;
    .label {
        padding-right: 10px;
        font-size: 14px;
        color: #666;
        display: inline-block;
        width: 30px;
        text-align: right;
    }
    &:last-child {
        margin-right: 0;
    }
    .label-group {
        width: 60px;
    }
}

.option-item1 {
    display: inline-block;
    font-size: 0;
    margin-right: 20px;
    margin-bottom: 20px;
    .label {
        padding-right: 10px;
        font-size: 14px;
        color: #666;
        display: inline-block;
        width: 84px;
        text-align: center;
    }
}
.select-btn-wrap {
    display: inline-block;
    margin-bottom: 20px;
}
.table-wrap {
    margin-top: 20px;
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
}
.link-btn {
    cursor: pointer;
    color: $a-link;
    font-size: 12px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-right: 1px solid $a-link;
    margin-right: 6px;
    padding-right: 6px;
    &:last-child {
        border-right: none;
        margin-right: 0;
        padding-right: 0;
    }
}
</style>
